import { render } from "./AlertSilenceTable.vue?vue&type=template&id=1d5d7792&scoped=true"
import script from "./AlertSilenceTable.vue?vue&type=script&lang=js"
export * from "./AlertSilenceTable.vue?vue&type=script&lang=js"

import "./AlertSilenceTable.vue?vue&type=style&index=0&id=1d5d7792&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5d7792"]])

export default __exports__